import {customAlphabet} from "nanoid"

export function myID() {
    let nanoID = customAlphabet('1234567890AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz-', 20);
    return nanoID();
}